import React, { useState, useEffect } from 'react';
import { useDeleteEndorsementMutation } from '../../../../../../store/Company/companyApiSlice';
import { useSelector } from "react-redux";
import EndorsementForm from './EndorsementForm';
import NotLoggedIn from './NotLoggedIn';
import { Button } from '../../../../../common';
import { ReactComponent as GoldenArrow } from '../../../../../../assets/endorseBanner/goldenArrow.svg'
import CommonTooltip from "../../../../../common/Tooltip.jsx";
import { ReactComponent as GrayHelp } from '../../../../../../assets/endorseBanner/help-Icon-white.svg';

const EndorsementButton = ({ company, trevexId }) => {
    const { token, userInfo } = useSelector((state) => state.auth);
    const [isFormVisible, setIsFormVisible] = useState(false);
    const [isEndorsed, setIsEndorsed] = useState(false);

    const [deleteEndorsement, { isLoading: isDeleting }] = useDeleteEndorsementMutation();

    useEffect(() => {
        const endorsement = userInfo?.individual[0]?.individualEndorsement.find(endorsement => endorsement.company === company?.companyID);
        setIsEndorsed(Boolean(endorsement))
    }, [userInfo, company?.companyID]);

    const endorsementID = userInfo?.individual[0]?.individualEndorsement.find(endorsement => endorsement.company === company?.companyID)?.endorsementID;

    const toggleFormVisibility = () => setIsFormVisible(!isFormVisible);

    const handleDeleteEndorsement = async () => {
        if (!endorsementID) return;
        try {
            await deleteEndorsement({ endorsementId: endorsementID, token }).unwrap();
            setIsEndorsed(false);
        } catch (err) {
            console.error('Failed to delete endorsement:', err);
        }
    };

    return (
        <div>
            {isEndorsed ? (
                <Button
                    onClick={handleDeleteEndorsement}
                    disabled={isDeleting}
                    classes={'min-w-[100px] bg-transparent flex gap-2 text-[#FFC36B] text-f14 sm:text-f16'}
                >
                    {isDeleting ? 'Removing...' : '✓ Endorsed'}
                </Button>
            ) : (
                <Button onClick={toggleFormVisibility} classes={'bg-transparent flex gap-2 text-[#FFC36B] text-f14 sm:text-f16'}>
                    <p>Endorse Now</p>
                    <GoldenArrow className='w-[15px] h-[15px] sm:w-[20px] sm:h-[20px] mt-[2px]' />

                    {<CommonTooltip styles={{ backgroundColor: '#EBF0F3', color: 'black', zIndex:9999999 }} id={'help-tooltip'} htmlContent={
                        <div className='max-w-[250px]'>
                            <p className='text-[16px]'>Impact of your <br/> Payment Timeliness Endorsement</p>
                            {/* <p className='text-left text-[12px]'>Your endorsement validates a company's timely payments, enhancing your business ties and their financial credibility, which can attract partners and better credit terms.</p> */}
                            <p className='text-left text-[12px]'>By endorsing a business for it's payment timeliness, you are not just strengthening your own business connections; you are also helping them build a reputation for reliability that draws in new partners and opens the door to more favorable financial opportunities.</p>
                        </div>
                    }>
                        <GrayHelp className='hidden sm:block w-[15px] h-[15px] sm:w-[20px] sm:h-[20px]' />
                    </CommonTooltip>}
                </Button>
            )}


            {isFormVisible && (
                <div className="fixed inset-0 z-50 flex items-center justify-center">
                    <div className="fixed inset-0 bg-transparent bg-opacity-50 backdrop-blur z-40"></div>
                    {userInfo ? (
                        <EndorsementForm onClose={() => { setIsFormVisible(false); }} company={company} trevexId={trevexId} token={token} />
                    ) : (
                        <NotLoggedIn onClose={toggleFormVisibility} company={company} trevexId={trevexId} />
                    )}
                </div>
            )}
        </div>
    );
};

export default EndorsementButton;
